import { Controller } from "@hotwired/stimulus"

// Shows/hides the accommodation picker based on the selected reservation option.
// When "hebergement" is selected: show accommodation block and make it required.
// When "libre" or "restauration": hide block, clear selection, remove required.
export default class extends Controller {
  static values = {
    hebergement: { type: String, default: "hebergement" }
  }

  static targets = ["option", "accommodationBlock", "accommodationRadio"]

  connect() {
    this.toggle()
  }

  change() {
    this.toggle()
  }

  toggle() {
    const selected = this.optionTargets.find((r) => r.checked)?.value
    const showAccommodation = selected === this.hebergementValue

    if (this.hasAccommodationBlockTarget) {
      this.accommodationBlockTarget.hidden = !showAccommodation
    }

    if (this.hasAccommodationRadioTarget) {
      this.accommodationRadioTargets.forEach((radio) => {
        radio.required = showAccommodation
        if (!showAccommodation) {
          radio.checked = false
        }
      })
      if (!showAccommodation && this.hasAccommodationBlockTarget) {
        const radioCards = this.application.getControllerForElementAndIdentifier(
          this.accommodationBlockTarget.querySelector("[data-controller~='radio-cards']"),
          "radio-cards"
        )
        radioCards?.select?.()
      }
    }
  }
}
